import React, { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import Toggle from 'material-ui/Toggle'
import StylesJS from './styles'
import Autosuggest from 'react-autosuggest'
import Debounce from 'utils/Debounce'

import Styles from './index.scss'
import theme from './autoSuggestTheme.scss'

import {
  toggleManagerDialog,
  getManagerSuggestions,
  resetManagerSuggestions,
  setSelectedManager,
  postSelectedManager,
} from 'reduxpath/ducks/Manager'

const AssignManagerDialog = props => {
  const [inputValue, setInputValue] = useState('')

  const isCancelButtonDisabled = props.isLoading
  const isAssignButtonDisabled = props.isLoading || props.selectedManager === null

  const actions = (
    <div className={Styles['btn-container']}>
      <button
        className={Styles['btn-cancel']}
        disabled={isCancelButtonDisabled}
        onClick={() => props.toggleManagerDialog(false)}
      >
        Cancel
      </button>
      <button
        className={Styles[isAssignButtonDisabled ? 'btn-disabled' : 'btn-confirm']}
        disabled={isAssignButtonDisabled}
        onClick={props.postSelectedManager}
      >
        Assign
      </button>
    </div>
  )

  const onSuggestionsFetchRequested = useCallback(
    Debounce(({ value }) => {
      if (value !== '') props.getManagerSuggestions(value)
    }, 400),
    []
  )

  const filteredSuggestedManagers = props.suggestedManagers.filter(suggestedManager =>
    !props.managers.some(manager => manager.profile.profileId === suggestedManager.profileId)
  )

  const renderSuggestion = suggestion => {
    return <div className={Styles['list-option']}>{suggestion.profileId}</div>
  }

  const inputProps = {
    placeholder: 'Enter a Profile ID/ Name/ Email',
    value: inputValue,
    onChange: (_, { newValue }) => setInputValue(newValue),
  }

  const selectedManagerNames = props.managers.length ?
    props.managers.map(manager => manager.profile.profileId).join(', ')
    : '-'

  return (
    <Dialog
      title="Assign workspace of Project Manager"
      titleStyle={StylesJS.titleStyles}
      actions={actions}
      actionsContainerStyle={StylesJS.actionsStyles}
      bodyStyle={StylesJS.contentStyles}
      open={props.isOpen}
      onRequestClose={() => props.toggleManagerDialog(false)}
    >
      <div className={Styles['auto-suggestion-wrapper']}>
        <div className={Styles['selected-manager']}>
          Selected Manager : {selectedManagerNames}
        </div>
        <div className={Styles['suggest-label']}>Enter search terms</div>
        <Autosuggest
          theme={theme}
          suggestions={filteredSuggestedManagers}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={props.resetManagerSuggestions}
          getSuggestionValue={profile => {
            props.setSelectedManager(profile)
            return profile.profileId
          }}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        />
        {/* className={`${Styles['empty-message-container']}`} */}
        <div className={Styles['suggest-info']}>
          Note: System only displays maximum top 50 suggestions from user input.
        </div>
      </div>
    </Dialog>
  )
}

const mapStateToProps = state => {
  return {
    isLoading: state.Manager.isLoading,
    isOpen: state.Manager.isManagerDialogOpen,
    suggestedManagers: state.Manager.suggestedManagers,
    selectedManager: state.Manager.selectedManager,
    managers: state.ProjectDetail.data.managers,
  }
}

const mapDispatchToProps = {
  toggleManagerDialog,
  getManagerSuggestions,
  resetManagerSuggestions,
  setSelectedManager,
  postSelectedManager,
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignManagerDialog)
